import deleteBookingServiceOperation from 'owa-service/lib/operation/deleteBookingServiceOperation';
import DeleteBookingServiceJsonResponse from 'owa-service/lib/contract/DeleteBookingServiceJsonResponse';
import DeleteBookingServiceResponseMessage from 'owa-service/lib/contract/DeleteBookingServiceResponseMessage';
import DeleteBookingServiceJsonRequest from 'owa-service/lib/contract/DeleteBookingServiceJsonRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import ItemId from 'owa-service/lib/contract/ItemId';

/**
 * Service call to delete a booking service.
 */
export default async function deleteBookingService(
    itemId: ItemId
): Promise<DeleteBookingServiceResponseMessage> {
    let request: DeleteBookingServiceJsonRequest = {
        Header: getJsonRequestHeader(),
        Body: {
            BookingServiceItemId: itemId,
        },
    };

    let response: DeleteBookingServiceJsonResponse = await deleteBookingServiceOperation(request);

    let result: DeleteBookingServiceResponseMessage = null;
    if (response && response.Body && response.Body.ResponseClass === 'Success') {
        result = response.Body;
    }

    return result;
}
